module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-1-APRILEOK-small-fe4ffac245f6e66178862455190e1cae.jpg";